export function getDeviceInfo() {
  const ua = navigator.userAgent;

  // --------------------
  // Browser detection
  // --------------------
  let browser = "Unknown";

  if (ua.includes("Edg")) browser = "Edge";
  else if (ua.includes("Chrome")) browser = "Chrome";
  else if (ua.includes("Firefox")) browser = "Firefox";
  else if (ua.includes("Safari")) browser = "Safari";

  // --------------------
  // OS detection
  // --------------------
  let os = "Unknown OS";

  if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (ua.includes("Android")) os = "Android";
  else if (ua.includes("Windows")) os = "Windows";
  else if (ua.includes("Mac")) os = "MacOS";
  else if (ua.includes("Linux")) os = "Linux";

  // --------------------
  // Device detection
  // --------------------
  let device = "Desktop";

  if (/Tablet|iPad/i.test(ua)) device = "Tablet";
  else if (/Mobi|Android/i.test(ua)) device = "Mobile";

  return {
    browser,
    os,
    device,
    userAgent: ua,
  };
}
